module.exports = __webpack_public_path__ + "static/media/4- proximite.dfb16e77.png";